import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { showAlert } from 'actions/common/alert';
import { downloadQuotation } from 'actions/orderAggregators/quotation';
import Total from 'components/OrderAggregators/components/Total';

const mapStateToProps = ({ orderAggregatorsQuotation }) => ({
  ...orderAggregatorsQuotation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      showAlert,
      downloadQuotation
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Total);



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/components/Total.js